module.exports = __webpack_public_path__ + "static/media/grid-item-a10.f38369a8.png";